export const visit = (vm, at) => {
vm(require("./availability/no.lyaml"));
vm(require("./typical-response-time/no.lyaml"));
vm(require("./default/no.lyaml"));
at({ "no-no": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};